module.exports = __webpack_public_path__ + "media/images/cover/1-5f26313de9b2b5b5119f93d83d45238c.jpg";